/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderFileVo } from './OrderFileVo';
import {
    OrderFileVoFromJSON,
    OrderFileVoFromJSONTyped,
    OrderFileVoToJSON,
    OrderFileVoToJSONTyped,
} from './OrderFileVo';

/**
 * 
 * @export
 * @interface ResponseOrderFileVo
 */
export interface ResponseOrderFileVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderFileVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderFileVo
     */
    message?: string;
    /**
     * 
     * @type {OrderFileVo}
     * @memberof ResponseOrderFileVo
     */
    data?: OrderFileVo;
}

/**
 * Check if a given object implements the ResponseOrderFileVo interface.
 */
export function instanceOfResponseOrderFileVo(value: object): value is ResponseOrderFileVo {
    return true;
}

export function ResponseOrderFileVoFromJSON(json: any): ResponseOrderFileVo {
    return ResponseOrderFileVoFromJSONTyped(json, false);
}

export function ResponseOrderFileVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderFileVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderFileVoFromJSON(json['data']),
    };
}

export function ResponseOrderFileVoToJSON(json: any): ResponseOrderFileVo {
    return ResponseOrderFileVoToJSONTyped(json, false);
}

export function ResponseOrderFileVoToJSONTyped(value?: ResponseOrderFileVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderFileVoToJSON(value['data']),
    };
}

